import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { TelegramLoginButton } from '../components/TelegramLoginButton';
import { useAuth } from '../hooks/useAuth';

export function LoginPage() {
  const { user, loading, config } = useAuth();
  const [error, setError] = useState<string | null>(null);

  if (loading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Загрузка…</div>;
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}
    >
      <div className="card" style={{ maxWidth: 400, width: '100%', textAlign: 'center' }}>
        <h1 style={{ margin: '0 0 0.5rem', fontSize: '1.5rem' }}>VPN Bot Panel</h1>
        <p style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>
          Войдите через Telegram. Доступ только для администраторов.
        </p>

        <TelegramLoginButton
          botUsername={config?.bot_username ?? ''}
          onError={setError}
        />

        {error && (
          <p style={{ color: 'var(--danger)', marginTop: '1rem', fontSize: '0.875rem' }}>
            {error}
          </p>
        )}
      </div>
    </div>
  );
}
